<template>
  <div>
    <b-table :fields="allFields" :items="items" >

      <template v-slot:cell(link)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <router-link v-translate v-if='data.item.link' :to="{ name: 'shipping', params: {id: data.item.link} }" target='_blank'> Go to shipment</router-link>
        <span v-if="data.item.csvError" v-html="data.item.csvError"></span>
        <span v-else>{{ data.item.err }}</span>
      </template>

      <!-- A custom formatted column -->
      <template v-slot:cell(external_link)="data" id='external-link-td'>
        <a :href="'//' + data.item.external_link" v-translate target='_blank'> Go to order</a>
      </template>

       <template slot="status" slot-scope="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <p>{{ data.value }}</p>
      </template>
    </b-table>
  </div>
</template>


<script>
export default {
  name: 'IntegrationCreateShippingSuccessMessage',
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'Id'
        }, {
          key: 'status',
          label: this.$gettext('Status')
        },
        {
          key: 'link',
          label: this.$gettext('Track shipment'),
          tdClass: 'link-tr'
        }
      ]
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    extraFields: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },
  computed: {
    allFields() {
      return this.fields.concat(this.extraFields)
    }
  }
}
</script>
<style lang="scss">
.link-tr {
  max-width: 30px;
  span {
    display: block;
    overflow: auto;
  }
}
</style>
